(() => {
  const script = document.currentScript;
  const measurementId = script?.dataset.measurementId || '';
  const sentObstructions = new Set();
  const recentIntents = new Map();
  let scanScheduled = false;

  const obstructionSelectors = {
    klaviyo: '[role="dialog"][aria-label="POPUP Form"], [role="dialog"][data-kl-scroll-locking-modal="true"]',
    location: '.header-town-selector-modal.active, .location-overlay.active',
    cookies: '.cookies-banner__overlay:not([hidden])',
  };

  function sendEvent(name, parameters) {
    const payload = {
      ...parameters,
      send_to: measurementId || undefined,
      transport_type: 'beacon',
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...payload });
  }

  function isVisible(element) {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }

  function visibleObstructions() {
    return Object.entries(obstructionSelectors)
      .filter(([, selector]) => Array.from(document.querySelectorAll(selector)).some(isVisible))
      .map(([name]) => name);
  }

  function activeCheckoutPath() {
    if (/^\/cart(?:\/|$)/.test(window.location.pathname)) return 'cart_page';
    if (document.querySelector('cart-drawer.active')) return 'cart_drawer';
    return '';
  }

  function termsState(path) {
    let selector = '';
    if (path === 'cart_page') selector = '[data-consent="terms"][form="cart"]';
    if (path === 'cart_drawer') selector = '[data-consent="terms"][form="CartDrawer-Form"]';
    if (!selector) return 'not_present';

    const input = document.querySelector(selector);
    if (!input) return 'not_present';
    return input.checked ? 'accepted' : 'not_accepted';
  }

  function blockerValue(blockers) {
    if (!blockers.length) return 'none';
    if (blockers.length === 1) return blockers[0];
    return 'multiple';
  }

  function recordIntent(path) {
    if (!path) return;
    const now = Date.now();
    if (now - (recentIntents.get(path) || 0) < 1500) return;
    recentIntents.set(path, now);

    const blockers = visibleObstructions();
    sendEvent('checkout_intent', {
      checkout_path: path,
      checkout_blocker: blockerValue(blockers),
      checkout_terms_state: termsState(path),
      event_category: 'checkout_path',
      event_label: path,
    });
  }

  function recordVisibleObstructions() {
    const path = activeCheckoutPath();
    if (!path) return;

    visibleObstructions().forEach((blocker) => {
      const key = `${path}:${blocker}`;
      if (sentObstructions.has(key)) return;
      sentObstructions.add(key);
      sendEvent('checkout_obstruction', {
        checkout_path: path,
        checkout_blocker: blocker,
        checkout_terms_state: termsState(path),
        event_category: 'checkout_obstruction',
        event_label: `${path}:${blocker}`,
      });
    });
  }

  function scheduleObstructionScan() {
    if (scanScheduled) return;
    scanScheduled = true;
    window.requestAnimationFrame(() => {
      scanScheduled = false;
      recordVisibleObstructions();
    });
  }

  function checkoutTrigger(target) {
    return target instanceof Element ? target.closest('[data-checkout-path]') : null;
  }

  document.addEventListener(
    'click',
    (event) => {
      const trigger = checkoutTrigger(event.target);
      if (!trigger) return;
      recordIntent(trigger.dataset.checkoutPath);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const submitter = checkoutTrigger(event.submitter);
      if (submitter) recordIntent(submitter.dataset.checkoutPath);
    },
    true
  );

  document.addEventListener('gotta:checkout-blocked', (event) => {
    const detail = event.detail || {};
    const path = detail.checkout_path || activeCheckoutPath() || 'unknown';
    const blocker = detail.checkout_blocker || 'unknown';
    sendEvent('checkout_blocked', {
      checkout_path: path,
      checkout_blocker: blocker,
      checkout_terms_state: termsState(path),
      event_category: 'checkout_blocked',
      event_label: `${path}:${blocker}`,
    });
  });

  window.addEventListener('blur', () => {
    window.setTimeout(() => {
      const active = document.activeElement;
      if (!(active instanceof HTMLIFrameElement)) return;
      const wrapper = active.closest('[data-checkout-path="accelerated_checkout"]');
      if (wrapper) recordIntent('accelerated_checkout');
    }, 0);
  });

  function start() {
    recordVisibleObstructions();
    new MutationObserver(scheduleObstructionScan).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden'],
    });
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
